module.exports = __webpack_public_path__ + "img/2021y_top1.a38b7ac6.jpg";